import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import { useHistory } from 'react-router-dom';
import Content from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content';

const ScenarioReselectionStepTemplate = ({
  resource,
}) => {
  const history = useHistory();

  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={BaseWizardStepOverride}
      resource={resource}
      layout={Content}
      onNext={() => history.push('/')}
    />
  );
};

ScenarioReselectionStepTemplate.defaultProps = {};

ScenarioReselectionStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioReselectionStepTemplate;
